import { render, staticRenderFns } from "./exodus.vue?vue&type=template&id=4f70e2f4&"
import script from "./exodus.vue?vue&type=script&lang=js&"
export * from "./exodus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports